import { showNotification } from "aldoo-ra/Notification"

export const copyContent = async (url, message) => {
  try {
    await navigator.clipboard.writeText(url)
    showNotification({
      message,
      className: "bg-primary text-text",
    })
    return true
  } catch (err) {
    console.error("Failed to copy: ", err)
    return false
  }
}